import { useEffect } from 'react';
import { Table, Input } from 'reactstrap';
import { Controller, useFieldArray } from 'react-hook-form';
import Icon from '@mdi/react';
import { mdiTrashCanOutline } from '@mdi/js';
import { PUBLIC_OFFICIAL } from '../constants';
import './ClientInformation.scss';

function ClientInformation({
  isEdit,
  isView = false,
  control,
  errors,
  detailsData,
}) {
  const clientDetails = detailsData?.clientDetails;
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: 'clientInformation',
  });

  const removeRow = index => {
    if (fields.length > 1) {
      remove(index);
    } else {
      replace({});
    }
  };

  useEffect(() => {
    if (
      isEdit &&
      clientDetails &&
      Array.isArray(clientDetails) &&
      clientDetails.length > 0
    ) {
      // Map API fields to form fields
      const mapped = clientDetails.map(item => ({
        clientName: item?.ClientName?.trim(),
        company: item?.Company?.trim(),
        contactNumber: item?.ContactNo?.trim(),
        projectName: item?.ProjectName?.trim(),
        publicOfficial: item?.PublicOfficial?.trim() === 'Y' ? 'Yes' : 'No',
      }));
      replace(mapped);
    } else if (fields.length === 0) {
      append({});
    }
  }, [clientDetails, replace, append]);

  return (
    <div className="new-travel-request-card p-3 bg-white">
      <div className="d-flex flex-row align-items-center justify-content-between w-100 mb-2">
        <div className="fw-semibold fs-5">Client Information</div>
        <button
          type="button"
          className="new-ntr-btn"
          onClick={() => append({})}
          disabled={isView}
        >
          Add New
        </button>
      </div>
      <div className="table-responsive">
        <div className="ntr-table-container">
          <Table
            className="options-table align-middle text-nowrap ntr-table"
            id="client-info-table"
          >
            <thead>
              <tr>
                <th className="text-center px-2">#</th>
                <th className="px-2">
                  Client Name <span className="text-danger-tr">*</span>
                </th>
                <th className="px-2">
                  Company <span className="text-danger-tr">*</span>
                </th>
                <th className="px-2">
                  Contact Number <span className="text-danger-tr">*</span>
                </th>
                <th className="px-2">
                  Project Name <span className="text-danger-tr">*</span>
                </th>
                <th className="px-2">Public Official</th>
                <th className="px-2 text-center">{}</th>
              </tr>
            </thead>
            <tbody>
              {fields.map((field, index) => (
                <tr key={field.id}>
                  <td className="text-center px-2 py-1">{index + 1}.</td>
                  <td className="px-2 py-1">
                    <Controller
                      control={control}
                      name={`clientInformation.${index}.clientName`}
                      render={({ field: element }) => (
                        <Input
                          {...element}
                          placeholder="Client Name"
                          className="border-0 ps-0"
                          disabled={isView}
                        />
                      )}
                    />
                    {errors.clientInformation?.[index]?.clientName && (
                      <div className="text-danger-tr">
                        {errors.clientInformation[index].clientName.message}
                      </div>
                    )}
                  </td>
                  <td className="px-2 py-1">
                    <Controller
                      control={control}
                      name={`clientInformation.${index}.company`}
                      render={({ field: element }) => (
                        <Input
                          {...element}
                          placeholder="Company"
                          className="border-0 ps-0"
                          disabled={isView}
                        />
                      )}
                    />
                    {errors.clientInformation?.[index]?.company && (
                      <div className="text-danger-tr">
                        {errors.clientInformation[index].company.message}
                      </div>
                    )}
                  </td>
                  <td className="px-2 py-1">
                    <Controller
                      control={control}
                      name={`clientInformation.${index}.contactNumber`}
                      render={({ field: element }) => (
                        <Input
                          {...element}
                          placeholder="Contact Number"
                          className="border-0 ps-0"
                          disabled={isView}
                        />
                      )}
                    />
                    {errors.clientInformation?.[index]?.contactNumber && (
                      <div className="text-danger-tr">
                        {errors.clientInformation[index].contactNumber.message}
                      </div>
                    )}
                  </td>
                  <td className="px-2 py-1">
                    <Controller
                      control={control}
                      name={`clientInformation.${index}.projectName`}
                      render={({ field: element }) => (
                        <Input
                          {...element}
                          placeholder="Project Name"
                          className="border-0 ps-0"
                          disabled={isView}
                        />
                      )}
                    />
                    {errors.clientInformation?.[index]?.projectName && (
                      <div className="text-danger-tr">
                        {errors.clientInformation[index].projectName.message}
                      </div>
                    )}
                  </td>
                  <td className="px-2 py-1">
                    <Controller
                      control={control}
                      name={`clientInformation.${index}.publicOfficial`}
                      render={({ field: element }) => (
                        <Input
                          {...element}
                          placeholder="Select"
                          type="select"
                          className="border-0 ps-0"
                          disabled={isView}
                        >
                          {PUBLIC_OFFICIAL.map(type => (
                            <option key={type.key} value={type.key}>
                              {type.value}
                            </option>
                          ))}
                        </Input>
                      )}
                    />
                  </td>
                  <td className="text-center px-2 py-1">
                    {index >= 0 && (
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={() => removeRow(index)}
                        disabled={isView}
                      >
                        <Icon
                          path={mdiTrashCanOutline}
                          size={0.7}
                          color="#D92D20"
                        />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}

export default ClientInformation;
